module.exports = __webpack_public_path__ + "img/digital-marketing.962c190a.svg";